import { adminPrefix } from "../../constants";

export const blogBannerApi = {
  FETCH_BLOG_BANNER: adminPrefix + "blog-banner",
  UPDATE_BLOG_BANNER: adminPrefix + "blog-banner/update",
};
